import { render } from "./fairPrice.vue?vue&type=template&id=19808804"
import script from "./fairPrice.vue?vue&type=script&lang=js"
export * from "./fairPrice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__